module.exports = __webpack_public_path__ + "img/bg999.e2c0e77a.png";